import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';

function formatCount(value: number): string {
  return new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 }).format(value);
}

export function renderStats(target: HTMLElement): void {
  const { collaborators, users, businesses } = SITE.statsFallback;

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-stats-section',
      id: 'comunidad',
      'aria-labelledby': 'stats-title',
    },
    [
      createEl('div', { className: 'sv-inner' }, [
        createEl('h2', { className: 'sv-section__title', id: 'stats-title' }, [SITE.statsSectionTitle]),
        createEl('p', { className: 'sv-stats-section__subtitle' }, [SITE.statsSectionSubtitle]),
        createEl(
          'div',
          {
            className: 'sv-stats-grid',
            role: 'region',
            'aria-live': 'polite',
            'aria-label': 'Resumen de registros en la plataforma',
          },
          [
            statCard('collaborators', SITE.statsLabels.collaborators, collaborators),
            statCard('users', SITE.statsLabels.users, users),
            statCard('businesses', SITE.statsLabels.businesses, businesses),
          ]
        ),
      ]),
    ]
  );

  target.appendChild(section);
}

function statCard(key: string, label: string, value: number): HTMLElement {
  return createEl('article', { className: 'sv-stat-card' }, [
    createEl('p', {
      className: 'sv-stat-card__value',
      'data-stat-value': key,
      textContent: formatCount(value),
    }),
    createEl('p', { className: 'sv-stat-card__label' }, [label]),
  ]);
}
